import AxiosHttpClient from '../utils/HttpClient';
import Logger from '../utils/Logger';
const TAG = 'UiNotificationManager';
export const WRAPPER_API_BASE_URL = `/o/v1/wrapper`;
const UI_USER_NOTIFICATION_URL = `${WRAPPER_API_BASE_URL}/ui_user_notification`;
export default class UiUserNotificationManager {
    static async loadNotification(type, url) {
        let requestUrl = UI_USER_NOTIFICATION_URL;
        if (url) {
            requestUrl = url;
        }
        Logger.info(TAG, `Loading ui notification setting spec from ${requestUrl}...`);
        const client = new AxiosHttpClient();
        const data = await client.get(requestUrl);
        return data.state;
    }
    static async saveNotification(uiUserNotificationSettingSpec, url) {
        let requestUrl = UI_USER_NOTIFICATION_URL;
        if (url) {
            requestUrl = url;
        }
        Logger.info(TAG, `Saving ui notification setting spec from ${requestUrl}...`);
        const client = new AxiosHttpClient();
        const data = await client.post(requestUrl, uiUserNotificationSettingSpec);
        return data.state;
    }
}
//# sourceMappingURL=UiUserNotificationManager.js.map